export default [
    {
        name: "login",
        path: "/login",
        component: () => import("@/views/login/Login"),
        meta: { layout: "Blank", menu: "", title: "Dot Account : Sign in" }
    },
    {
        name: "find-ID",
        path: "/findId",
        component: () => import("@/views/login/FindId"),
        meta: { layout: "Blank", menu: "", title: "Dot Account : Find Username" }
    },
    {
        name: "find-password",
        path: "/findPwd",
        component: () => import("@/views/login/FindPwd"),
        meta: { layout: "Blank", menu: "", title: "Dot Account : Reset Password" }
    },
    {
        name: "join",
        path: "/join",
        component: () => import("@/views/login/Join"),
        meta: { layout: "Blank", menu: "", title: "Dot Account : Sign up" }
    },
];
